import { CampaignDetailsResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class PostRunReviewedCampaign extends BaseAdapter<CampaignDetailsResponse[]> implements AdapterInterface {
  rawResponse: CampaignDetailsResponse[];

  async adaptResponse(request: number): Promise<void> {
    await this.fetchApiResponse('/api/run-reviewed-campaign', HTTPMethod.Post, { campaign_communication_id: request });
  }
}
